const Unrecognized = Symbol("EnvLightType.Unrecognized");

const EnvLightTypes = [
    "exr",
    "env",
];

export default EnvLightTypes;
export { EnvLightTypes, Unrecognized };
